import React from "react";
import logo from "../assets/logo.png";

const partnerButtonStyle = {
  marginTop: "auto",
  padding: "10px 14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  borderRadius: "8px",
  textDecoration: "none",
  fontWeight: "bold",
  display: "inline-block",
  transition: "background-color 0.2s ease",
};


const cardStyle = {
  border: "1px solid #ddd",
  borderRadius: "14px",
  padding: "24px",
  backgroundColor: "#fff",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const logoStyle = {
  height: "70px",
  margin: "0 auto 10px",
  objectFit: "contain",
};

const wideLogoStyle = {
  maxWidth: "240px",
  width: "100%",
  height: "70px",
  margin: "0 auto 10px",
  objectFit: "contain",
};

const ClientExchangePlus = () => {
  return (
    <div
  style={{
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "30px 20px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  }}
>

      {/* HERO */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <img
  src={logo}
  alt="Client Exchange"
  style={{
    width: "300px",
    maxWidth: "90%",
    marginBottom: "4px",
  }}
/>
        <h1
  style={{
    color: "#2e7d32",
    marginTop: "0px",     // 👈 THIS pulls it UP
    marginBottom: "10px",
  }}
>

          Client Exchange Plus
        </h1>

        <p style={{ fontSize: "1.1rem", color: "#555" }}>
          Member benefits and useful resources for Client Exchange members.
        </p>
      </div>

      {/* FEATURE: Vic Ski Riders */}
<div
  style={{
    background: "#e8f5e9",
    padding: "20px",
    borderRadius: "12px",
    marginBottom: "30px",
    textAlign: "center",
  }}
>
  <h2 style={{ color: "#2e7d32" }}>
    Work Smarter. Ride More.
  </h2>

  <p style={{ marginBottom: "15px" }}>
    Client Exchange™ proudly supports Vic Ski Riders — connecting business owners
    with a lifestyle beyond the workday.
  </p>

  <a
    href="https://vicskiriders.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={partnerButtonStyle}
  >
    Explore Vic Ski Riders →
  </a>
</div>

      {/* PLUS PARTNERS */}
      <h2 style={{ marginBottom: "20px" }}>
   Member Benefits
   <p style={{ fontSize: ".90rem", color: "#777", marginBottom: "20px" }}>
  Client Exchange™ highlights third-party businesses for user convenience. We are not affiliated with, endorsed by, or responsible for any third-party services.
</p>
</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "24px",
        }}
      >
        {/* Anthem Workwear */}
        <div style={cardStyle}>
          <img
            src="/images/anthemworkwear.jpg"
            alt="Anthem Workwear"
            style={logoStyle}
          />
          <h3>Anthem Workwear</h3>
          <p>
            Premium workwear designed for tradies and service professionals —
            rugged, comfortable, and built to last.
          </p>
          <a
  href="https://www.anthemworkwear.com.au"
  target="_blank"
  rel="noopener noreferrer"
  style={partnerButtonStyle}
>
  Visit Website →
</a>

        </div>

        {/* ByDea */}
        <div style={cardStyle}>
          <img src="/images/bydea.png" alt="ByDea" style={logoStyle} />
          <h3>ByDea Creative Studio</h3>
          <p>
            Professional branding, websites, and digital design services tailored
            for service businesses.
          </p>
          <a
            href="https://bydea.com.au"
            target="_blank"
            rel="noopener noreferrer"
            style={partnerButtonStyle}
          >
            Visit Website →
          </a>
        </div>

        {/* Concise Financial Services */}
<div style={cardStyle}>
  <img
    src="/images/concisefinancialservices.png"
    alt="Concise Financial Services"
    style={wideLogoStyle}
  />

  <h3>Concise Financial Services</h3>

  <p>
    Residential and commercial finance solutions, helping individuals and businesses
    find competitive lending options through experienced mortgage brokers.
  </p>

  <a
    href="https://concisefinancial.com.au/"
    target="_blank"
    rel="noopener noreferrer"
    style={partnerButtonStyle}
  >
    Visit Website →
  </a>
</div>


   {/* OzMobiles */}
<div style={cardStyle}>
  <img src="/images/ozmobiles.png" alt="OzMobiles" style={logoStyle} />
  <h3>OzMobiles</h3>
  <p>
    Refurbished phones, tablets and mobile devices for contractors and small businesses across Australia.
  </p>
  <a
    href="https://ozmobiles.com.au"
    target="_blank"
    rel="noopener noreferrer"
    style={partnerButtonStyle}
  >
    Visit Website →
  </a>
</div>

        {/* MowerPower */}
        <div style={cardStyle}>
          <img
            src="/images/mowerpower.png"
            alt="MowerPower"
            style={logoStyle}
          />
          <h3>MowerPower</h3>
          <p>
            Equipment, servicing, and parts from a trusted national outdoor power
            supplier.
          </p>
          <a
            href="https://www.mowerpower.com.au"
            target="_blank"
            rel="noopener noreferrer"
            style={partnerButtonStyle}
          >
            Visit Website →

            
          </a>
        </div>
        {/* Vic Ski Riders */}
<div style={cardStyle}>
  <img
    src="/images/vicskiriders.png"
    alt="Vic Ski Riders"
    style={logoStyle}
  />

  <h3>Vic Ski Riders</h3>

  <p>
    Work smarter. Ride more. Vic Ski Riders connects a growing community of jet
    ski enthusiasts across Victoria.
  </p>

  <a
    href="https://vicskiriders.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={partnerButtonStyle}
  >
    Visit Website →
  </a>
</div>
      </div>
    </div>
  );
};

export default ClientExchangePlus;
